import http from 'axios'

export default {
  getParametresExploitation: (username) => {
    return http.get(`/web/v1/${username}/parametres-exploitation`)
  },
  createParametresExploitation: (username, parametresExploitation) => {
    return http.post(`/web/v1/${username}/parametres-exploitation`, parametresExploitation)
  },
  updateParametresExploitation: (username, parametresExploitation) => {
    return http.put(`/web/v1/${username}/parametres-exploitation`, parametresExploitation)
  },
  getParametresExploitationComplet: (username) => {
    return http.get(`/web/v1/${username}/parametres-exploitation/is-complet`)
  },
  getParametresExploitationPotentielSol: (username, parametresExploitation) => {
    return http.post(`/web/v1/${username}/parametres-exploitation/potentiel-sol`, parametresExploitation)
  },
  getProfondeurSolParDefaut: (codeTypeSol) => {
    return http.get(`/web/v1/parametres-exploitation/profondeur-sol/default?codeTypeSol=${codeTypeSol}`)
  },
  getParametresExploitationTypesSol: () => {
    return http.get(`/web/v1/parametres-exploitation/types-sol`)
  },
  getParametresExploitationTypesProduction: () => {
    return http.get(`/web/v1/parametres-exploitation/types-production`)
  },
  getParametresExploitationRessourceEffluent: () => {
    return http.get(`/web/v1/parametres-exploitation/ressource-effluent`)
  },
  getParametresExploitationStockageCereales: () => {
    return http.get(`/web/v1/parametres-exploitation/stockage-cereales`)
  },
  getParametresExploitationAteliersCulture: () => {
    return http.get(`/web/v1/parametres-exploitation/ateliers-culture`)
  }
}
